"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PasswordValidityChecks = exports.PasswordMaxLength = exports.PasswordMinLength = void 0;
exports.PasswordMinLength = 8;
exports.PasswordMaxLength = 70;
exports.PasswordValidityChecks = [/[a-z]/, /[A-Z]/, /\d/, /[^A-z\d]/];
